import { useState, useEffect } from "react";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import { faSquareMinus } from "@fortawesome/free-solid-svg-icons";
import EditModal from "../ui/EditModal.js";
import { normalizar } from "../../common/stringNormalizer.js";
import { usePatologia } from "../../context/PatologiaContext"
import Swal from "sweetalert2";

const AddPatologia = () => {
  const { patologiaActiva, setPatologiaActiva } = usePatologia(); 
  const [filtroEstado, setFiltroEstado] = useState("activas");
  const [selectedPatologia, setSelectedPatologia] = useState(null);
  const [Nombre, setNombre] = useState("");
  const [Descripcion, setDescripcion] = useState("");
  const [Patologias, setPatologias] = useState([]);
  const [mostrarDescripcion, setMostrarDescripcion] = useState({});
console.log("nombre", Nombre);
  useEffect(() => {
    getPatologias();
  }, []);

  const editFields = [
    { name: "Nombre", label: "Nombre Patología", type: "text", required: true },
    { name: "Descripcion", label: "Descripción Patología", type: "text", required: false }
  ];

  const getPatologias = async () => {
    const response = await api.get(`/patologias`);
    setPatologias(response.data);
  };

  const createPatologias = async (e) => {
    e.preventDefault();

    const existe = Patologias.some(
      (patologia) => normalizar(patologia.Nombre) === normalizar(Nombre)
    );

    if (existe) {
      Swal.fire({
        icon: "warning",
        title: "Duplicado",
        text: "Ya existe una patología con ese nombre.",
        confirmButtonColor: "#3085d6"
      });
      return;
    }

    try {
      await api.post(`/patologias`, {
        Nombre,
        Descripcion,
      });
      setNombre("");
      setDescripcion("");
      getPatologias();
      Swal.fire({
        icon: "success",
        title: "Guardado",
        text: "La patología fue guardada exitosamente.",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text: "Ocurrió un problema al guardar la patología.",
      });
    };
  }

  const handleEditPatologia = async (values) => {
    try {
      await api.patch(
        `/patologias/updatePatologia/${values.IdPatologia}`,
        { Nombre: values.Nombre, Descripcion: values.Descripcion }
      );
      Swal.fire({
        icon: "success",
        title: "Patología actualizada",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error("Error al actualizar:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al actualizar la patología.",
      });
    }
    setSelectedPatologia(null);
    getPatologias();
  };

  const cambiarEstado = async (IdPatologia) => {
  try {
    const patologiaActual = Patologias.find(p => p.IdPatologia === IdPatologia);
    const nuevoEstado = patologiaActual.estado === 1 ? "desactivada" : "activada";

    await api.patch(`/patologias/cambiarEstadoPatologia/${IdPatologia}`);
    getPatologias();

    Swal.fire({
      icon: "success",
      title: `Patología ${nuevoEstado}`,
      text: `La patología fue ${nuevoEstado} correctamente.`,
      timer: 1500,
      showConfirmButton: false
    });
  } catch (error) {
    console.log(error);
    Swal.fire({
      icon: "error",
      title: "No se pudo cambiar el estado",
      text: error.response?.data?.msg || "Ocurrió un error desconocido.",
    });
  }
};
const filtrarPatologias = () => {
  if (filtroEstado === "activas") {
    return Patologias.filter(p => p.estado === 1);
  }
  if (filtroEstado === "inactivas") {
    return Patologias.filter(p => p.estado === 0);
  }
  return Patologias;
};




  const columnas = [

    {
      name: 'Nombre',
      selector: row => row.Nombre,
      sortable: true,
      width: '15vw',
    },
    {
      name: 'Descripción',
      cell: (row) => {
        const toggleDescripcion = () => {
          setMostrarDescripcion(prev => ({
            ...prev,
            [row.IdPatologia]: !prev[row.IdPatologia]
          }));
        };

        const descripcion = row.Descripcion || "Sin descripción";
        const mostrarBoton = row.Descripcion && row.Descripcion.length > 40;

        return (
          <div style={{ display: 'flex', alignItems: 'center', width: '30vw' }}>
            <div style={{
              flex: 1,
              whiteSpace: mostrarDescripcion[row.IdPatologia] ? 'normal' : 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}>
              {!mostrarDescripcion[row.IdPatologia]
                ? (descripcion.length > 40 ? descripcion.substring(0, 40) + '...' : descripcion)
                : descripcion}
            </div>
            {mostrarBoton && (
              <button className="btn" onClick={(e) => {
                e.preventDefault();
                toggleDescripcion();
              }}>
                {mostrarDescripcion[row.IdPatologia] ? "Ver Menos" : "Ver Más"}
              </button>
            )}
          </div>
        );
      },
      sortable: true,
      width: '30vw',
    },
    {
      cell: (row) =>
        row.estado === 1 ? (
          <FontAwesomeIcon
            icon={faSquarePlus}
            style={{ color: "#37ff00", cursor: "pointer" }}
            size="2xl"
            onClick={() => cambiarEstado(row.IdPatologia)}
          />
        ) : (
          <FontAwesomeIcon
            icon={faSquareMinus}
            style={{ color: "#ff0000", cursor: "pointer" }}
            size="2xl"
            onClick={() => cambiarEstado(row.IdPatologia)}
          />
        ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      compact: true
    },
    {
      cell: row => (
        <button
          className="button is-small is-info"
          title="Editar"
          onClick={() => setSelectedPatologia(row)}
        >
          <FontAwesomeIcon icon={faPencil} />
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      compact: true
    }
  ];

const paginationOptionsES = {
  rowsPerPageText: 'Filas por página',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos',
};
  return (
    <div className="columns is-centered">
      <div>
        <div className="notification is-primary">
          <strong>Ingresa el nombre de la patologia.</strong>
        </div>

        <form onSubmit={createPatologias}>
          <div className="field">
            <div className="container">
              <label className="label required">Nombre Patologia</label>
              <div className="control">
                <input
                  type="text"
                  className="input"
                  value={Nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  placeholder="Nombre"
                  required
                />
              </div>
            </div>
          </div>

          <div className="field">
            <div className="container">
              <label className="label">Descripción Patologia</label>
              <div className="control">
                <input
                  type="text"
                  className="input"
                  value={Descripcion}
                  onChange={(e) => setDescripcion(e.target.value)}
                  placeholder="Descripcion"
                />
              </div>
            </div>
          </div>

          <div className="field">
            <button type="submit" className="button is-success">
              Guardar
            </button>
          </div>
        </form>

        <br />

        <div style={{ border: '1px solid gray', borderRadius: '8px' }}>


<div style={{ display: 'flex', gap: '10px', margin: '10px 0' }}>
  {["todas", "activas", "inactivas"].map((estado) => (
    <button
      key={estado}
      onClick={() => setFiltroEstado(estado)}
      type="button"
      style={{
        padding: "6px 16px",
        border: "none",
        borderRadius: "20px",
        backgroundColor: filtroEstado === estado ? "#d1f5d3" : "#f0f2f5",
        color: filtroEstado === estado ? "#075e54" : "#333",
        fontWeight: filtroEstado === estado ? "bold" : "normal",
        boxShadow:
          filtroEstado === estado
            ? "inset 0 0 0 1px #1ebea5"
            : "inset 0 0 0 1px #ccc",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        fontSize: "0.9rem",
      }}
    >
      {estado.charAt(0).toUpperCase() + estado.slice(1)}
    </button>
  ))}
</div>

<div className="field" style={{ margin: "20px 0" }}>
  <label className="label">Patología activa</label>
  <div className="control">
    <div className="select">
      <select
        value={patologiaActiva}
        onChange={(e) => setPatologiaActiva(e.target.value)}
      >
        <option value="">-- Selecciona --</option>
        {Patologias.map((p) => (
          <option key={p.IdPatologia} value={p.Nombre}>
            {p.Nombre}
          </option>
        ))}
      </select>
    </div>
  </div>
</div>

          <DataTable
            pagination
              paginationComponentOptions={paginationOptionsES}
            columns={columnas}
           data={filtrarPatologias()}
            dense={false}
            responsive={false}
          />
        </div>

        {selectedPatologia && (
          <EditModal
            fields={editFields}
            initialValues={selectedPatologia}
            onSubmit={handleEditPatologia}
            title="Editar Patologia"
            onClose={() => setSelectedPatologia(null)}
          />
        )}
      </div>
    </div>
  );
};

export default AddPatologia;